<atx-media-preview
  class="media-preview"
  [class.video-like-content]="isVideoLikeContent$ | async"
  [media]="mainMedia$ | async"
  [epicShowPlayerTemplateRef]="epicShowPlayer"
  [imageBreakpoints]="imageBreakpoints"
  [enablePictureInPicture]="enablePictureInPicture$ | async"
  [videoAttributes]="{
    muted: true,
    autoplay: true,
    controls: true,
    disablePlaceholder: true
  }"
  [objectFit]="listMediaObjectFit$ | async"
>
</atx-media-preview>

<ng-template #epicShowPlayer>
  <epc-epic-show-player
    class="player"
    [listId]="listId"
    [isOwner]="isOwner"
    [media]="mainMedia$ | async"
    [mediaMetadata]="parsedMediaMetadata$ | async"
    [enableFullScreen]="true"
    (epicShowFullScreenChanged)="onFullscreenChanged()"
  >
  </epc-epic-show-player>
</ng-template>
